import React, { lazy } from 'react';
import { Route, Navigate } from 'react-router-dom';

// Analytics — canonical UI at /analytics (components/analytics-v2).
const AnalyticsV2 = lazy(() => import('../components/analytics-v2'));

// System Atlas (database / pages / flows wiki — iframes /api/atlas/page)
const SystemAtlas = lazy(() => import('../components/SystemAtlas'));

export const coreRoutes = (
  <>
    <Route path="/" element={<Navigate to="/analytics" replace />} />
    <Route path="/system-atlas" element={<SystemAtlas />} />
    <Route path="/analytics" element={<AnalyticsV2 />} />
    <Route path="/analytics/:page" element={<AnalyticsV2 />} />
    <Route path="/analytics-v2" element={<Navigate to="/analytics" replace />} />
    <Route path="/analytics-v2/:page" element={<Navigate to="/analytics" replace />} />
    <Route path="/ads" element={<Navigate to="/analytics/marketing" replace />} />
    <Route path="/analytics/amazon/profitability" element={<Navigate to="/analytics/amazon" replace />} />
  </>
);
